export default "__VITE_PUBLIC_ASSET__ba54d83e__"